import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericDeleteDialogComponent } from './generic-delete-dialog.component';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';

@NgModule({
  declarations: [
    GenericDeleteDialogComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule
  ],
  exports: [
    GenericDeleteDialogComponent
  ]
})
export class GenericDeleteDialogModule { }
